import React from "react";
import { Col, Row } from "react-bootstrap";

function ContactCard({ title, desc, icon }) {
  return (
    <Row>
      <Col md={4} lg={2} sm={12} xs={12}>
        <div
          style={{
            height: "50px",
            width: "50px",
            backgroundColor: "#9dc318",
            borderRadius: 100,
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            marginBottom: 10,
          }}
        >
          {icon}
        </div>
      </Col>
      <Col md={8} lg={10} sm={12} xs={12}>
        <h3>{title}</h3>
        <p
          style={{
            wordBreak: "break-word",
          }}
        >
          {desc}
        </p>
      </Col>
    </Row>
  );
}

export default ContactCard;
